import * as React from 'react';

import { AnalyticsContext } from '../../utils/analyticsContext';
import { INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { MapModalMobileHeader } from '../../components/MapModal/parts';
import { TSellerType } from '../NewbuildingCallButton/tracking';
import { NewbuildingFavoriteButton } from '../NewbuildingFavoriteButton';
import { INFRASTRUCTURE_ANALYTICS_CONTEXT } from './DistrictInfrastructureMapHeaderContainer';

export interface IDistrictInfrastructureMapMobileHeaderContainerProps {
  newbuilding?: INewbuildingSummaryCellValue;
  title: string;
  onBack(): void;
}

/**
 * Мобильная шапка карты района: стрелка «назад», название ЖК и кнопка избранного.
 * Крестик закрытия модалки на мобильной версии заменяет стрелка.
 */
export function DistrictInfrastructureMapMobileHeaderContainer({
  newbuilding,
  title,
  onBack,
}: IDistrictInfrastructureMapMobileHeaderContainerProps): React.JSX.Element {
  const sellerType: TSellerType = newbuilding && newbuilding.builders.length > 0 ? 'builders' : 'agents';

  return (
    <MapModalMobileHeader
      backTestId="district-infrastructure-map-back"
      rightSlot={
        newbuilding && (
          <AnalyticsContext.Provider value={INFRASTRUCTURE_ANALYTICS_CONTEXT}>
            <NewbuildingFavoriteButton
              gaLabel={newbuilding.fullUrl}
              isFavorite={newbuilding.isFavorite}
              newbuildingId={newbuilding.id}
              sellerType={sellerType}
              url={newbuilding.fullUrl}
              variant="icon"
            />
          </AnalyticsContext.Provider>
        )
      }
      testId="district-infrastructure-map-header"
      title={newbuilding?.name ?? title}
      onBack={onBack}
    />
  );
}
